// extracted by mini-css-extract-plugin
export var changeIcon = "_62-4";
export var container = "_62-0";
export var divider = "_62-7";
export var externalLinkIcon = "_62-1";
export var green = "_62-5";
export var helpCircleIcon = "_62-3";
export var iconButton = "_62-2";
export var red = "_62-6";